// extracted by mini-css-extract-plugin
module.exports = {"campoData":"InputDataCombo_campoData__1_IK8"};